import { List as MuiList, ListProps as MuiListProps } from '@mui/material';

export type ListProps = MuiListProps;

export const List = MuiList;
